module.exports = __webpack_public_path__ + "img/evento-header.a7bb85f4.png";